import { Anchor, Group } from "@mantine/core";

import { TextWrapper } from "@/components/TextWrapper";

import { ADD_CLIENT_FLAGS_LABEL, NO_CLIENT_FLAGS_ADDED_MESSAGE } from "../constants/client-flags";
import { CLIENT_FLAG_ROW_PROPS } from "../constants/ui";

/**
 * Stands in for the flag list of a client with none, in the same row a flag takes: the message
 * where a flag's name goes, and `+ Add Flags` where its priority goes.
 */
export default function ClientFlagsEmptyRow({ onAdd }: { onAdd: () => void }) {
  return (
    <Group {...CLIENT_FLAG_ROW_PROPS} data-testid="client-flags-empty">
      <TextWrapper c="gray.7">{NO_CLIENT_FLAGS_ADDED_MESSAGE}</TextWrapper>
      <Anchor
        fz="xs"
        fw={600}
        type="button"
        c="burgundy.9"
        onClick={onAdd}
        underline="never"
        component="button"
        data-testid="client-flags-add"
      >
        {ADD_CLIENT_FLAGS_LABEL}
      </Anchor>
    </Group>
  );
}
